export enum CompanyName {
  Sravni = 'sravni',
  Marketplace = 'mpl',
  SravniLabs = 'sravniLabs',
  Fanteh = 'fanteh',
}
